import { atom } from 'recoil'
import { IProtocol } from '@/pages/Equipment/equipment.types.ts'

export interface IProtocolsAtomState {
  items: IProtocol[]
}

const protocolsAtom = atom<IProtocolsAtomState>({ key: 'protocols', default: { items: [] } })
export default protocolsAtom
